import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

import { AIProps, PromptPayload } from './ai.interface';
import { SuggestionsProps, SuggestionsRequest } from './suggestions.interface';
import getEnvConfig from '../../../../../utils/config/env';

export const aiApi = createApi({
    reducerPath: 'ai',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['AI', 'SUGGESTIONS'],

    endpoints: builder => ({
        createAI: builder.mutation<AIProps, PromptPayload>({
            query: payload => ({
                url: `/shops/${payload.id}/ai`,
                method: 'POST',
                body: { ...payload },
            }),
            transformResponse: (response: { data: AIProps }) => {
                return response.data;
            },
            invalidatesTags: ['AI'],
        }),

        readAI: builder.query<AIProps, number>({
            query: id => {
                return {
                    url: `/shops/${id}/ai`,
                };
            },
            transformResponse: (res: { data: AIProps }) => {
                return res.data;
            },
            providesTags: ['AI'],
        }),

        readSuggestions: builder.query<SuggestionsProps[], number>({
            query: id => {
                return {
                    url: `/shops/${id}/ai-tooltips`,
                };
            },
            transformResponse: (res: {
                data: { tooltips: SuggestionsProps[] };
            }) => {
                return res.data.tooltips;
            },
            providesTags: ['SUGGESTIONS'],
        }),

        createSuggestions: builder.mutation<
            SuggestionsProps[],
            SuggestionsRequest
        >({
            query: payload => ({
                url: `/shops/${payload.id}/ai-tooltips`,
                method: 'POST',
                body: { tooltips: payload.tooltips },
            }),
            transformResponse: (response: { data: SuggestionsProps[] }) => {
                return response.data;
            },
            invalidatesTags: ['SUGGESTIONS'],
        }),
    }),
});

export const {
    useCreateAIMutation,
    useLazyReadAIQuery,
    useLazyReadSuggestionsQuery,
    useCreateSuggestionsMutation,
} = aiApi;
